import GlobalMessage from './components/GlobalMessage-redux';

export default GlobalMessage;
